import Cookie, { JWT_COOKIE_NAME } from "../../lib/cookie";
import api from "./api";

// Function to check if the user has paid
export const checkHasPaidAPI = async () => {
  try {
    const token = Cookie.get(JWT_COOKIE_NAME);
    if (token) {
      const response = await api.get("/has-paid", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      // Validate response status
      if (response.status !== 200) {
        throw new Error(
          `Failed to check payment status: ${response.status} ${response.statusText}`
        );
      }

      // Validate response data
      if (!response.data || typeof response.data.has_paid !== "boolean") {
        throw new Error(
          "Invalid response format: Expected a boolean 'hasPaid'"
        );
      }

      // Return the payment status
      return response.data;
    }
    return {
      has_paid: false,
      purchased_books: [],
    };
  } catch (error) {
    console.error("checkHasPaidAPI Error:", error.message);
    throw error; // Re-throw for saga or error handling
  }
};
